import { render, staticRenderFns } from "./CustomSingle.vue?vue&type=template&id=3419f6c9"
import script from "./CustomSingle.vue?vue&type=script&lang=js"
export * from "./CustomSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports